import { render, staticRenderFns } from "./tabbar3.vue?vue&type=template&id=d4ef6d7a&scoped=true"
import script from "./tabbar3.vue?vue&type=script&lang=js"
export * from "./tabbar3.vue?vue&type=script&lang=js"
import style0 from "./tabbar3.vue?vue&type=style&index=0&id=d4ef6d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ef6d7a",
  null
  
)

export default component.exports